import { __ } from '@wordpress/i18n';
import React, { useRef, useState } from 'react';
import './Notice.scss';

export default function Notice() {
    const [show, setShows] = useState(true);
    const [additionalClass, setAdditionalClass] = useState('');
    const noticeRef = useRef(null); // Create a reference to the notice div


    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setAdditionalClass('fade-out');
    //     }, 3000); 

    //     return () => clearTimeout(timer); // Cleanup timeout on unmount
    // }, []);

    // useEffect(() => {
    //     if (additionalClass === 'fade-out') {
    //         const timer = setTimeout(() => {
    //             if (noticeRef.current) {
    //                 noticeRef.current.style.display = 'none'; // Hide the element safely
    //             }
    //         }, 1000);

    //         return () => clearTimeout(timer); // Cleanup timeout on unmount
    //     }
    // }, [additionalClass]);

    return (
        <>
            {
                show && 
                    <div ref={noticeRef} className={`ultimate-security-notice ${additionalClass}`}>
                        <div className="notice-tick" >
                            <img src={ultimate_security_ajax_obj.imageUrl+'noticeTick.svg'} alt="" />
                        </div>
                        <div className="notice-content">
                            {__(
                                'All changes have been applied correctly, ensuring your preferences are now in effect.',
                                "ultimate-security"
                            )}
                        </div>
                        <div className="notice-close" onClick={() => setShows(false)}>
                            <img src={ultimate_security_ajax_obj.imageUrl+'noticeClose.svg'} alt="" />
                        </div>
                    </div>
                
            }
        </>
    );
}
